import { type ReactNode } from "react";
import { Drawer as DrawerPrimitive } from "vaul";

import { Drawer, type DrawerRootProps } from "..";
import { cn } from "../../../utils";

export interface MobileDrawerProps extends DrawerRootProps {
  trigger?: ReactNode;
  title?: string;
  className?: string;
}

export const MobileDrawer = ({ trigger, title, children, className, ...drawerProps }: MobileDrawerProps) => {
  return (
    <Drawer.Root direction="bottom" {...drawerProps}>
      {trigger && <Drawer.Trigger asChild>{trigger}</Drawer.Trigger>}
      <Drawer.Portal>
        <Drawer.Overlay className="fixed inset-0 bg-neutral-10" />
        <Drawer.Content
          className={cn(
            "m-4 flex flex-col items-center gap-4 overflow-hidden rounded-xl bg-white p-4 pt-4!",
            className
          )}
        >
          {/* Mobile draggable indicator */}
          <div className="h-1.5 w-16 shrink-0 rounded-full bg-neutral-90" />

          <DrawerPrimitive.Title className={cn("text-base font-bold text-neutral-10", !title && "hidden")}>
            {title}
          </DrawerPrimitive.Title>

          {children}
        </Drawer.Content>
      </Drawer.Portal>
    </Drawer.Root>
  );
};

MobileDrawer.displayName = "MobileDrawer";

export default MobileDrawer;
